function handleFirstTab(e) {
  if (e.keyCode === 9) { // tab
      document.body.classList.add('user-is-tabbing');
      window.removeEventListener('keydown', handleFirstTab);
  }
}
window.addEventListener('keydown', handleFirstTab);

window.Branch = window.Branch || {};
window.Branch.cart = window.Branch.cart || {};

$(function() {
  /* Reduced motion: Replace slideToggle(), slideDown(), slideUp() with toggle(), show(), hide() */
  var oSlideToggle = jQuery.fn.slideToggle;
  jQuery.fn.slideToggle = function() {
    if(Simplistic.reducedMotion()){
       return jQuery.fn.toggle.apply(this, arguments); 
    }else{
      return oSlideToggle.apply(this, arguments);
    }
  };
  var oSlideDown = jQuery.fn.slideDown;
  jQuery.fn.slideDown = function() {
    if(Simplistic.reducedMotion()){
       return jQuery.fn.show.apply(this, arguments); 
    }else{
      return oSlideDown.apply(this, arguments);
    }
  };
  var oSlideUp = jQuery.fn.slideUp;
  jQuery.fn.slideUp = function() {
    if(Simplistic.reducedMotion()){
       return jQuery.fn.hide.apply(this, arguments); 
    }else{
      return oSlideUp.apply(this, arguments);
    }
  };
  /* End of Reduced Motion */

  jQuery.fn.sortDomElements = (function() {
      return function(comparator) {
          return Array.prototype.sort.call(this, comparator).each(function(i) {
                this.parentNode.appendChild(this);
          });
      };
  })();

  if(!window.Branch.functions.isTouchDevice()) {
    $('body').addClass('isNotMobile'); 
  }

  $(document).on("click", ".quantity-box .minus", function(e) {
      e.preventDefault();
      var wrapper = $(this).parent();
    try {
        wrapper.find('input[type=number]').get(0).stepDown();
        wrapper.find('input[type=number]').change();
      } catch(e) {
        var value = (parseInt(wrapper.find('input[type=number]').val())-1);
        wrapper.find('input[type=number]').val((value>=0 ? value : 0));
        wrapper.find('input[type=number]').change();
      }
  });
  $(document).on("click", ".quantity-box .plus", function(e) {
    e.preventDefault();
      var wrapper = $(this).parent();
    try {
        wrapper.find('input[type=number]').get(0).stepUp();
        wrapper.find('input[type=number]').change();
      } catch(e) {
        var value = (parseInt(wrapper.find('input[type=number]').val())+1);
        wrapper.find('input[type=number]').val(value);
        wrapper.find('input[type=number]').change();
      }
  });

  $(document).on("keypress", ".quantity-box input", function(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      e.target.blur();
    }
  });

  $(document).on('click', '.hover-tooltip', function(e){
    if(window.Branch.functions.isTouchDevice() || window.innerWidth < 900){
      if ($(this).hasClass('active')){
        $(this).closest('.variants').find('.hover-tooltip').each(function(){
          $( this ).removeClass( "active" );
        })
      } else {
        $(this).closest('.variants').find('.hover-tooltip').each(function(){
          $( this ).removeClass( "active" );
        })
        $(this).addClass('active');
      }
      
      e.preventDefault();
    }
  });

  $(document).on('keydown', '.hover-tooltip:focus', function(e){
    if (e.which == 32) { //Spacebar
       if ($(this).hasClass('active')){
        $(this).closest('.variants').find('.hover-tooltip').each(function(){
          $( this ).removeClass( "active" );
        })
      } else {
        $(this).closest('.variants').find('.hover-tooltip').each(function(){
          $( this ).removeClass( "active" );
        })
        $(this).addClass('active');
      }
    }
    if (e.which == 13) { //Enter
       if ($(this).hasClass('active')){
        $(this).closest('.variants').find('.hover-tooltip').each(function(){
          $( this ).removeClass( "active" );
        })
      } else {
        $(this).closest('.variants').find('.hover-tooltip').each(function(){
          $( this ).removeClass( "active" );
        })
        $(this).addClass('active');
      }
    }
  });

 var arrayVariantsOption0=[];
var targetIdOption0 = [];
      $('input[type=radio][name=option-0]').change(function(e) {
          let target0 = e.target;
        
          switch (target0.id) {
              case target0.id:
              while( arrayVariantsOption0.length > 0) {
   arrayVariantsOption0.pop();
}
              
              while( targetIdOption0.length > 0) {
   targetIdOption0.pop();
}
                   arrayVariantsOption0.push(target0.value);
              targetIdOption0.push(target0.id);
              if(document.querySelector('.product-wrap .addons')){
                document.querySelector('.product-wrap .addons').style.display="block";
              }
              
                  break;
          
          }
        
      });


var arrayVariantsOption1=[];
var targetIdOption1 = [];


      $('input[type=radio][name=option-1]').change(function(e_one) {
          let target1 = e_one.target;
        
          switch (target1.id) {
              case target1.id:
              while( arrayVariantsOption1.length > 0) {
   arrayVariantsOption1.pop();
}
              
              while( targetIdOption1.length > 0) {
   targetIdOption1.pop();
}
                   arrayVariantsOption1.push(target1.value);
              targetIdOption1.push(target1.id);
              if(document.querySelector('.product-wrap .addons')){
               document.querySelector('.product-wrap .addons').style.display="block";
              }
              
                  break;
          
          }
        
      });

      var arrayVariantsOption2=[];
      var targetIdOption2 = [];


      $('input[type=radio][name=option-2]').change(function(e_two) {
          let target2 = e_two.target;
        
          switch (target2.id) {
              case target2.id:
              while( arrayVariantsOption2.length > 0) {
   arrayVariantsOption2.pop();
}
              
              while( targetIdOption2.length > 0) {
   targetIdOption2.pop();
}
                   arrayVariantsOption2.push(target2.value);
              targetIdOption2.push(target2.id);
              if(document.querySelector('.product-wrap .addons')){
               document.querySelector('.product-wrap .addons').style.display="block";
              }
              
                  break;
          
          }
        
      });

var arrayVariantsOptionStickyMobile0 = [];
var targetIdOptionMobileSticky0 = [];
$('input[type=radio][name=option-mobile-sticky-0]').change(function(e) {
    let target0 = e.target;

    switch (target0.id) {
        case target0.id:
            while (arrayVariantsOptionStickyMobile0.length > 0) {
                arrayVariantsOptionStickyMobile0.pop();
            }

            while (targetIdOptionMobileSticky0.length > 0) {
                targetIdOptionMobileSticky0.pop();
            }
            arrayVariantsOptionStickyMobile0.push(target0.value);
            targetIdOptionMobileSticky0.push(target0.id);
            if (document.querySelector('.product-wrap .addons')) {
                document.querySelector('.product-wrap .addons').style.display = "block";
            }

            break;

    }

});


var arrayVariantsOptionStickyMobile1 = [];
var targetIdOptionMobileSticky1 = [];


$('input[type=radio][name=option-mobile-sticky-1]').change(function(e_one) {
    let target1 = e_one.target;

    switch (target1.id) {
        case target1.id:
            while (arrayVariantsOptionStickyMobile1.length > 0) {
                arrayVariantsOptionStickyMobile1.pop();
            }

            while (targetIdOptionMobileSticky1.length > 0) {
                targetIdOptionMobileSticky1.pop();
            }
            arrayVariantsOptionStickyMobile1.push(target1.value);
            targetIdOptionMobileSticky1.push(target1.id);
            if (document.querySelector('.product-wrap .addons')) {
                document.querySelector('.product-wrap .addons').style.display = "block";
            }

            break;

    }

});

var arrayVariantsOptionStickyMobile2 = [];
var targetIdOptionMobileSticky2 = [];


$('input[type=radio][name=option-mobile-sticky-2]').change(function(e_two) {
    let target2 = e_two.target;

    switch (target2.id) {
        case target2.id:
            while (arrayVariantsOptionStickyMobile2.length > 0) {
                arrayVariantsOptionStickyMobile2.pop();
            }

            while (targetIdOptionMobileSticky2.length > 0) {
                targetIdOptionMobileSticky2.pop();
            }
            arrayVariantsOptionStickyMobile2.push(target2.value);
            targetIdOptionMobileSticky2.push(target2.id);
            if (document.querySelector('.product-wrap .addons')) {
                document.querySelector('.product-wrap .addons').style.display = "block";
            }

            break;

    }

});


  const selectMatchingOption = function(element, addonHandle, bundleVariantId, bundleOption1, bundleOption2, bundleOption3){
    if(bundleVariantId){
      if(bundleOption1){
        let option1Name = bundleOption1.split("#")[0].toLowerCase().replace(' ', '-');
        let option1Value = bundleOption1.split("#")[1];

        document.querySelector(`.product-wrap--quick-view .swatch[data-option-name="${option1Name}"] input[value="${option1Value}"]`).click();
      }

      if(bundleOption2){
        let option2Name = bundleOption2.split("#")[0].toLowerCase().replace(' ', '-');
        let option2Value = bundleOption2.split("#")[1];
        
        document.querySelector(`.product-wrap--quick-view .swatch[data-option-name="${option2Name}"] input[value="${option2Value}"]`).click();
      }

      if(bundleOption3){
        let option3Name = bundleOption3.split("#")[0].toLowerCase().replace(' ', '-');
        let option3Value = bundleOption3.split("#")[1];
        
        document.querySelector(`.product-wrap--quick-view .swatch[data-option-name="${option3Name}"] input[value="${option3Value}"]`).click();
      }

      // document.querySelector(`.product-wrap--quick-view .swatch[data-option-name="${variantMatch['add-on-option-name'].toLowerCase().replace(' ', '-')}"] input[value="${value}"]`).click();


    } 
    if(document.querySelector(`#add-on-matches`)){
      let addOnMatches = JSON.parse(document.querySelector(`#add-on-matches`).innerHTML);
      let productOptions = [];
      for(let i = 0; i < 3; i++){
        if(document.querySelector(`main .product-wrap .add-to-cart-form .swatch[data-option-index="${i}"]`)){
          productOptions.push(document.querySelector(`main .product-wrap .add-to-cart-form .swatch[data-option-index="${i}"]`).getAttribute('data-option-name'));
        }
      }
      addOnMatches.forEach((addOnMatch) => {
        if(addonHandle == addOnMatch[`add-on-handle`]){
          addOnMatch['variant-matches'].forEach((variantMatch) => {
            productOptions.forEach((productOption, index) => {

              if(variantMatch['option-name'].toLowerCase().replace(' ', '-') == productOption ){
                let value;
                let matchValue;
                if(index == 0){matchValue = arrayVariantsOption0[0]} else if(index == 1 && arrayVariantsOption1){matchValue = arrayVariantsOption1[0]} else if(index == 2 && arrayVariantsOption2){matchValue = arrayVariantsOption2[0]} 
                
                if(matchValue && variantMatch['non-identical-values-to-match']){
                  variantMatch['non-identical-values-to-match'].forEach((nonIdenticalValuePair) => {
                    if(nonIdenticalValuePair.value.toLowerCase().replace(' ', '-') == matchValue.toLowerCase().replace(' ', '-')){
                      matchValue = nonIdenticalValuePair['add-on-value'];
                    }
                  })
                }

                if(matchValue){
                  value = matchValue;
                }

                if(value){
                  document.querySelector(`.product-wrap--quick-view .swatch[data-option-name="${variantMatch['add-on-option-name'].toLowerCase().replace(' ', '-')}"] input[value="${value}"]`).click();
                }
              }
            })
          })
        }
      })
    }

  /* See if addon has alt price to cross out */
  if(element[0].closest('.addons__container') || element[0].closest('.cart-addons')){
    let clicked = element[0].classList.contains('item') || element[0].classList.contains('checkbox-custom-label') || element[0].closest('.checkbox-custom-label');
    if(clicked == true){
      let priceElement = element[0].querySelector('.price .deal .addon-price');
      if(priceElement && priceElement.getAttribute('data-price-modification') == "true"){
        document.querySelectorAll(`.main-product__item[data-quick-view="true"] span[data-price="deal"]`).forEach((deal) => {
          deal.setAttribute('data-modified', true)
        })
      }
  }
  }

  }


  /********* QUICK VIEW *********/
  var quickView = function(element, trigger, freeGift, atcText) {
    var url = element.data('url');
    $('#loading-overlay').show();
      
    // console.log('element', element)
    // console.log('url', url)

    $.ajax({
      url: url,
      cache: false
    }).success(function(data){


      
      $('#loading-overlay').hide();
      Simplistic.openModal(data, 'quick-view', trigger, element);

      
      let buttonText = 'SELECT ADD ON';
      if(atcText){
        buttonText = atcText;
      }

      if (trigger === "add-on-quick-view-link") {
        // as of now only used for the addon quick view

        let variantOptionSelector = document.querySelector(`.options[data-quick-view="true"] .select-variant#product-select-${addonId} option[value="${bundleVariantId}"]`);
        let available = true;

        if(variantOptionSelector && variantOptionSelector.getAttribute('data-variant-avaiable') == "false"){
          available = false;
        }

        var addonId = element.data('addon-id');
        var addonPrice = element.data('addon-price');
        var addonHandle = element.data('addon-handle');
        var addonAllVariantsAvailable = element.data('addon-all-variants-available') == "true";
        var addonBundle = element.data('bundle');
        var soldOutButton = addonAllVariantsAvailable ? `<div class="content-soldout ${available ? 'hide' : ''} " style="width:100%"><span class="btn" disabled>NOT AVAILABLE</span></div>` : `<div class="content-soldout ${available ? 'hide' : ''} " style="width:100%"><a href="#" class="btn chat-with-sales-button-pdp">Contact Us</a></div>`;
        var instockButton = `<div class="content-available" style="width:100%"><span onclick="addToCartAddOns(${addonId}, ${addonBundle})" class="btn">${buttonText}</span></div>`;
        $('.quick-view .qty-btn-wrap').removeClass( "flex flex-wrap" ).hide();
        $('.quick-view .addon-add-btn').html(soldOutButton + instockButton);
        $('.quick-view .product-clyde-quick-view').hide();
        $('.quick-view .main-product .page-container').css('padding-bottom', '0');

        let sideCartAddonDiscount = element.closest('.item') && element.closest('.item').attr('data-bundle-add-on') == "true" && parseInt(element.closest('.item').attr('data-bundle-discount')) > 0;
        if(sideCartAddonDiscount){
          $('.quick-view .main-product__item').attr('data-bundle-discount', parseInt(element.closest('.item').attr('data-bundle-discount')));
        }

        $('.quick-view .main-product__item').closest('.tingle-modal').attr('data-add-on-quick-view-link', true);

        selectMatchingOption(element, addonHandle);
      }
      else if (trigger === "quick-view-link") {
        // as of now only used for the addon quick view
        var addonId = element.data('addon-id');
        var addonPrice = element.data('addon-price');
        var addonHandle = element.data('addon-handle');
        var addonAllVariantsAvailable = element.data('addon-all-variants-available') == "true";
        var bundleVariantId = element.data('bundle-variant-id');
        var bundleOption1 = element.data('bundle-variant-option1');
        var bundleOption2 = element.data('bundle-variant-option2');
        var bundleOption3 = element.data('bundle-variant-option3');

        let variantOptionSelector = document.querySelector(`.options[data-quick-view="true"] .select-variant#product-select-${addonId} option[value="${bundleVariantId}"]`);
        let available = true;
        

        if(variantOptionSelector && variantOptionSelector.getAttribute('data-variant-avaiable') == "false"){
          available = false;
        }

        var soldOutButton = addonAllVariantsAvailable ? `<div class="content-soldout ${available ? 'hide' : ''} " style="width:100%"><span class="btn" disabled>NOT AVAILABLE</span></div>` : `<div class="content-soldout ${available ? 'hide' : ''} " style="width:100%"><a href="#" class="btn chat-with-sales-button-pdp">Contact Us</a></div>`;
       var instockButton = `<div class="content-available ${available ? '' : 'hide'}" style="width:100%"><span data-bundle-variant-id=${bundleVariantId} data-product-id=${addonId} onclick="window.Branch.addons.quickViewHandleATC(${bundleVariantId}, ${addonId})" 
          class="btn">${bundleVariantId ? 'SELECT BUNDLE' : `${buttonText}`}</span></div>`;
        $('.quick-view .qty-btn-wrap').removeClass( "flex flex-wrap" ).hide();
        $('.quick-view .addon-add-btn').html(soldOutButton + instockButton)
        $('.quick-view .main-product .page-container').css('padding-bottom', '0');

        $('.quick-view .product-clyde-quick-view').hide();

        selectMatchingOption(element, addonHandle, bundleVariantId, bundleOption1, bundleOption2, bundleOption3);
        if(freeGift){
          $('.quick-view .addon-add-btn .content-available span').html('SELECT FREE GIFT');
          $('.quick-view .price-installments-wrapper').hide();
        }
      }
      else if (trigger === "bundle-builder-form") {
        $('.quick-view .main-product .page-container').css('padding-bottom', '0');

      }
      else {
        var variant_id = $('.quick-view .product-clyde-quick-view').data('variant-id');
        if(typeof Clyde !== 'undefined'){
          Clyde.setActiveProduct(variant_id);
          loadClydeContractQuickview(variant_id);
          $('.quick-view .product-clyde-quick-view .clyde-pdp').on('click', function(e){
              showClydeModal(false);
          });
  
          $('.quick-view #add-to-cart-button').on('click', function(e){
          if (!Clyde.getActiveProduct() || Clyde.getActiveProduct().contracts.length === 0) {
              return true; 
            }
            // Coverall solution to prevent this site's other ATC behavior while we perform the contract adds or modal actions.
            e.preventDefault();
            e.stopPropagation();
              showClydeModal(true);
          });
        }
      }
    });
    return false;
  }
  $(document).on('click', '[pdp-bundle] .quick-view-btn', function(){
    $(this).addClass('clicked')
    quickView($(this))
  });
  $(document).on('click', '.product-tile .quick-view-link', function(){
    quickView($(this))
  });
  $(document).on('click', '.addons:not(.new) .quick-view-link', function(){
    quickView($(this), "quick-view-link")
  });

  $(document).on('click', '.pdp-fake-promo-swatch .quick-view-link', function(e){
    e.preventDefault();
    var scope = $(this);
    var addonId = scope.data('addon-id');

    // If this fake swatch has an associated addon, check if it's already selected
    if(addonId){
      var input = $(`.checkbox-custom[data-addon-id='${addonId}']`);

      if(input.length > 0 && input.is(':checked')){
        // Addon is already selected, uncheck it to remove from cart
        input.prop('checked', false).trigger('change');

        // Update fake promo swatch visual state
        const parentItem = scope.closest('.pdp-fake-promo-swatch__item');
        const container = scope.closest('.pdp-fake-promo-swatch');

        if(parentItem.length > 0){
          parentItem.removeClass('swatch-active');
        }

        // Check if any other addons are still active
        const hasActiveAddon = $('.pdp-fake-promo-swatch__item.swatch-active').length > 0;
        if(container.length > 0){
          if(hasActiveAddon){
            container.addClass('has-active-addon');
          } else {
            container.removeClass('has-active-addon');
          }
        }
      } else {
        // Addon not selected, open quick-view to add it
        quickView($(this), "quick-view-link")
      }
    } else {
      // No addon associated, proceed with normal quick-view
      quickView($(this), "quick-view-link")
    }
  });

  // Handle clicking on the current product's fake promo swatch (Standard option)
  $(document).on('click', '.pdp-fake-promo-swatch__item[data-current="true"] .pdp-fake-promo-swatch__link', function(e){
    e.preventDefault();

    // Find any active addon in the fake promo swatch section
    const activeSwatchItem = $('.pdp-fake-promo-swatch__item.swatch-active');

    if(activeSwatchItem.length > 0){
      // Get the addon ID from the active swatch's quick-view link
      const addonId = activeSwatchItem.find('.quick-view-link').data('addon-id');

      if(addonId){
        // Find and uncheck the addon checkbox
        const input = $(`.checkbox-custom[data-addon-id='${addonId}']`);
        if(input.length > 0 && input.is(':checked')){
          input.prop('checked', false).trigger('change');

          // Update fake promo swatch visual state
          activeSwatchItem.removeClass('swatch-active');

          // Update container class
          const container = $(this).closest('.pdp-fake-promo-swatch');
          if(container.length > 0){
            container.removeClass('has-active-addon');
          }
        }
      }
    }
  });

  // Sync fake promo swatch visual state when addon checkbox changes
  $(document).on('change', '.checkbox-custom[data-addon-id]', function(){
    const addonId = $(this).data('addon-id');
    const isChecked = $(this).is(':checked');

    // Find the corresponding fake swatch
    const fakeSwatch = $(`.pdp-fake-promo-swatch .quick-view-link[data-addon-id='${addonId}']`);

    if(fakeSwatch.length > 0){
      const parentItem = fakeSwatch.closest('.pdp-fake-promo-swatch__item');
      const container = fakeSwatch.closest('.pdp-fake-promo-swatch');

      if(isChecked){
        // Addon was checked, add active state
        if(parentItem.length > 0){
          parentItem.addClass('swatch-active');
        }
        if(container.length > 0){
          container.addClass('has-active-addon');
        }
      } else {
        // Addon was unchecked, remove active state
        if(parentItem.length > 0){
          parentItem.removeClass('swatch-active');
        }

        // Check if any other addons are still active
        const hasActiveAddon = $('.pdp-fake-promo-swatch__item.swatch-active').length > 0;
        if(container.length > 0){
          if(hasActiveAddon){
            container.addClass('has-active-addon');
          } else {
            container.removeClass('has-active-addon');
          }
        }
      }
    }
  });

  $(document).on('click', '.doorbusters__parent .quick-view-link, .image-text-side-by-side__button-container .quick-view-link', function(e){
    quickView($(this), "add-on-quick-view-link", null, 'Add to Cart')
  });

  $(document).on('click', '.cart-addons .quick-view-link', function(){
    quickView($(this), "add-on-quick-view-link")
  });

  $(document).on('click', '.addons-loading-state .quick-view-link', function(){
    quickView($(this), "quick-view-link")
  });

   $(document).on('click', '.cart-free-shipping .quick-view-link', function(){
    quickView($(this), "quick-view-link", true)
  });

  $(document).on('click', '.bundle-builder-form__quick-view-link:not([data-selected="true"])', function(){
    quickView($(this), "bundle-builder-form")
  });

  $(document).on('click', '.comparison-chart__quick-view-link', function(){
    quickView($(this), "comparison-chart")
  });

  //for new template
  
  $(document).on('click', '.addons.new .item .quick-view-link', function(e){
    e.preventDefault();
    var scope = $(this);
    var input = $(`.checkbox-custom[data-addon-id='${scope.data('addon-id')}']`);

    // console.log('quick view!');

    if(!input.is(':checked')){
      quickView($(this), "quick-view-link")
    }else{
      input.prop('checked', false).trigger('change');
    }
  
});

  if($('#side-cart').length > 0) { 
    initSideCart();
  }$('body').delegate('.add-to-cart-form', 'submit', function(){
          if(validateAddCart($(this))) {
            addToCart($(this));
          }
          return false;
      });$(window).scroll($.throttle(15, function(){
    if($(this).scrollTop()<=200) {
      $('.scrollup').fadeOut();
    } else {
      $('.scrollup').fadeIn();
    }if( $(this).scrollTop()>=80 ) {
        $('.header-drop').addClass('scroll');
      } else {
        $('.header-drop').removeClass('scroll');
        // let slideDown = document.querySelector('.collection-filters-mobile-slide-down');
        // let utilityBarHeight = document.querySelector('.toggle-header__utility-bar') ? document.querySelector('.toggle-header__utility-bar').offsetHeight : 0;
        // if(slideDown && slideDown.style.top !== ''){``
        //   slideDown.style.top = `${parseInt(slideDown.style.top.replace('px', '')) + utilityBarHeight}px`
        // }
      }}));

  var $element = $("#header .main-menu"),
  $target = $(".header-drop .custom-new-header-flex .logo-container"),
  $targetExistingNav = $(".header-drop .custom-new-header-flex .main-menu"),
  $clone;

  $clone = $element.clone( true );
  $targetExistingNav.remove();
  
  $clone.insertAfter( $target )
  setupDropdownMenus();

  if($(window).width() < 601){
    $('.responsive-table-wrapper').scroll(function(){
      if($(this).scrollLeft() > 20){
        $('.responsive-table-shadow').addClass('middle');
      }else{
        $('.responsive-table-shadow').removeClass('middle');
      }
      if($(this).scrollLeft() > (500 - $(window).width())){
        $('.responsive-table-shadow').addClass('end');
      }else{
        $('.responsive-table-shadow').removeClass('end');
      }
    });
  }
});

function setupDropdownMenus(){
var config = {
  over: function () {
    $(this).find('.submenu:first').slideDown();
  }, 
  timeout: 400, 
  out: function () {
    $(this).find('.submenu:first').slideUp();
  }
};
$('.main-menu .has-dropdown').hoverIntent(config);

$(document).on('keydown', '.main-menu .has-dropdown a:focus', function(e){
  if (e.which == 32) { //Spacebar
    e.preventDefault();
    $(this).next().slideToggle();
  }
  if (e.which == 40) { //Arrow Down
    e.preventDefault();
    $(this).next().slideDown();
  }
  if (e.which == 38) { //Arrow Up
    e.preventDefault();
    $(this).next().slideUp();
  }
});
$(document).on('keydown', '.main-menu .has-dropdown .has-dropdown a:focus', function(e){
  if (e.which == 39) { //Arrow Right
    e.preventDefault();
    $(this).next().slideDown();
  }
  if (e.which == 37) { //Arrow Left
    e.preventDefault();
    $(this).next().slideUp();
  }
});
}

function validateAddCart(form) {
if(form.find('input[name=id]').val()=='') {
      var allOptionsSelected;
      if(form.find('.single-option-selector').length > 0) {
          allOptionsSelected = true;
          form.find('.single-option-selector').each(function(){
              if($(this).val()=="") {
                  allOptionsSelected = false;
                  return false;
              }
          });
      } else {
          allOptionsSelected = false;
      }
      
      if(allOptionsSelected) {
          var errorMsg = form.find('.validation-msg').text();
          if(errorMsg) {
            alert(errorMsg);
          } else {
            alert("The selected variant is sold out.");
          }
      } else {
        var labels = [];
          form.find('.options label').each(function(key, obj){
              labels.push($(obj).text().replace(':', '').trim());
          });
          alert("You must select a "+labels.join('/')+".");
      }
      return false;
  }
  return true;
}

function initSideCart() {
$('.header .cart-wrap').click(function(e){
    e.stopPropagation();
    let sideCart = document.querySelector('#side-cart');
    if(sideCart.getAttribute('data-initialized') !== true){
      sideCart.setAttribute('data-initialized', true);
      window.Branch.cart.fetchUpdateCart();

      window.Branch.cart.updateFreeShippingThreshold();
    }
    setupClydeCartPrompts();
    if(window.innerWidth < 900 && document.querySelector('.menu-mobile-improved') && document.querySelector('.menu-mobile-improved').getAttribute('data-status') == 'open'){
      window.Branch.nav.handleNavLinkClick('click-outside')
    }
    showSideCart(true);
    return false;
  });

  $(document).click(function(event){
    if(!$(event.target).closest('#side-cart').length && !$(event.target).closest('.quick-view').length && !$(event.target).closest("#shopify-payment-terms-modal").length && !$(event.target).closest("#fsa-hsa-modal-content").length && $(event.target).attr('id')!="loading-overlay" && $('#side-cart').hasClass('open')) {
      hideSideCart();
    }
  });
}

// Old Cart

function addToCartQuickView(form, callback, id){
$('#loading-overlay').show();
  if(modal) modal.close();
  let shipping = '';
  let msbdInput = document.querySelector(`.msbd-message__input[data-variant-id="${id}"]`);
  if(id && msbdInput){
    shipping = msbdInput.value;
  }
  var date_obj_string = `properties%5B_ship_date=${shipping.replaceAll(' ', '%20')}&`
  var formSerialized = date_obj_string.concat(form.serialize());

  var productJs = form.closest('.initialized').data('productjs');
  if(productJs) {
    $(document).trigger("addToCart", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
  } else {
    $(document).trigger("addToCart", [form]);
  }

  var dataString = formSerialized && shipping !== '' ? formSerialized : form.serialize();

$.ajax({
  type: 'POST',
  url: '/cart/add.js',
  data: dataString,
  dataType: 'json',
  error: addToCartFail,
      success: function(){
        if(productJs) {
          $(document).trigger("addToCartSuccess", [productJs.getProduct(), productJs.getCurrentVariant(), form]);
        } else {
          $(document).trigger("addToCartSuccess", [form]);
        }
          if(callback) {
            callback();
          } else {
              addToCartSuccess();
          }
      },
  cache: false

});
}

function addToCart (form) {
var btn = document.getElementById("add-to-cart-button");
var productId = $(form).attr('data-product-id');
var variants = [];
var variantId = $(form).find('[name^=id]').val();
var variantMinQuantity = document.querySelector(`form[action="/cart/add"] input[value="${variantId}"`).getAttribute('data-min-quantity');
var bundleVariants = $(form).find('input.bundle-products');
var addonVariants = $('#addon-products-for-atc');
var quantityCount = $(form).find(`input[name~='quantity']`).val() || 1;
let singleProductSuccessfullyAdded = false;
let msbdData = JSON.parse(document.querySelector(`#variant_ship_date_metafield_values--${productId}`).innerText);
if (addonVariants.length) {
  var addons = JSON.parse(addonVariants.val() || '[]');
  addons.forEach(function(v){
    if(v.bundle && v.bundleConstituents.length > 0){
      v.bundleConstituents.forEach((bundleConstituent) => {
        variants.push({variantId: bundleConstituent.variantId, quantity: bundleConstituent.quantity, shipping: bundleConstituent.shipping, addon_origin: 'pdp'});
      })
    } else {
      variants.push({variantId: v.variantId, quantity: v.quantity, shipping: v.shipping, mainProductQuantity: v.mainProductQuantity, addon_origin: 'pdp'});
    }
  });
}
if (bundleVariants && bundleVariants.length > 0 && bundleVariants.val && bundleVariants.val != "") {
  var bundles = JSON.parse(bundleVariants.val()).replaceAll(' ', '').replaceAll('[', '').replaceAll(']', '').replaceAll('=>', ':').split('},{');
  bundles.forEach(function(v, index){
        let variantId = bundles[index].split('"variantId":')[1].split(',"')[0];
        let variantQuantity = parseInt(bundles[index].split('"quantity":')[1])
        variants.push({variantId: variantId, quantity: variantQuantity, shipping: msbdData[variantId], origin: 'legacy-bundles'})
  }); 
} else if (variantId)  {var shipping = document.getElementById(`msbd-message__input--${productId}`).value;variants.push({variantId: variantId, quantity: variantMinQuantity, shipping: shipping});
}


if(variants.length > 0) {
  $('#loading-overlay').show();

  if(modal) modal.close();

  var queue = [];

  let greaterQuantityOfMainProductThanAddOn = false;
  let quantities = [];
  let mainProductQuantityOverall = 1;
  let addOnProductQuantity = 1
  let mainProductMinQuantity = 0

  $.each(variants, function() {
    var child = this;
    if(!quantities.includes(child.quantity)){
      quantities.push(child.quantity);
    }
    if(parseInt(child.mainProductQuantity) > 1){
      greaterQuantityOfMainProductThanAddOn = true;
      mainProductQuantityOverall = parseInt(child.mainProductQuantity);
      addOnProductQuantity = parseInt(child.quantity);
    }
    if(parseInt(variantId) == parseInt(child.variantId)){
      mainProductMinQuantity = parseInt(child.quantity)
    }
  })

  let lowestMinQuantity = quantities.sort(function(a, b) {return a - b;});
  let loops = Math.ceil(quantityCount / variantMinQuantity);
    for (let i = 0; i < loops; i++) {
      $.each(variants, function() {
        var child = this;
          queue.push({
            variantId: child.variantId,
            quantity: child.quantity,
            shipping: child.shipping || "",
            origin: child.origin || "",
            addon_origin: child.addon_origin || ""
          });
      });
    }
  
  var errors = '';

  var postRequest = function(variantId, itemQuantity, itemProperties, multipleVariants, lastItemInQueue){
    if(!multipleVariants){
        singleProductSuccessfullyAdded = true;
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {id: variantId, quantity: itemQuantity, properties: itemProperties},
        dataType: 'json',
    }).error(function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        errors += response.description + '<br />';
    }).always(function(){
        if (lastItemInQueue && itemProperties && itemProperties._order_tag) {
            let cartAttributes = {'order_tag': itemProperties._order_tag};
            updateCartAttributes(cartAttributes);
        } else {
            addItem();
        }
    });
};

var updateCartAttributes = function(cartAttributes){
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {attributes: cartAttributes},
        dataType: 'json',
    }).error(function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        errors += response.description + '<br />';
    }).done(function(){
        addItem();
    });
};

  var closeEverything = function(){
    if (errors!='') { //mobile doesn't have a close button
      $('#loading-overlay').hide();
      modal = new tingle.modal({
          closeMethods: ['overlay', 'button', 'escape'],
          closeLabel: "Close",
          cssClass: ['message'],
          //onClose: event currently broken
          beforeClose: function(){
            $('#loading-overlay').show();
            addToCartSuccess();
            return true;
          }
        });
      modal.setContent('<div class="error-itemincart"><i class="close animation lnr lnr-cross-circle" onclick="modal.close();"></i>'+errors+'</div>');
      modal.open();
    } else {
      addToCartSuccess();
    }
  }

  var addItem = function() {
    if(variants.length > 1){
      if(queue.length > 0) {
        var item = queue.shift();
        let lastItemInQueue = queue.length == 1;
        let itemProperties = {'_ship_date': item.shipping};
        if(item['addon_origin']){
          itemProperties['_addon_origin'] = item['addon_origin'];
        }
        if(item['origin']){
          itemProperties['_order_tag'] = 'legacy-bundles'
        }
        postRequest(item.variantId, item.quantity, itemProperties, true, lastItemInQueue)
      } else {
        closeEverything();
      }
    } else {
      if(!singleProductSuccessfullyAdded){
        let itemProperties = {'_ship_date': variants[0].shipping};
        if(variants[0]['addon_origin']){
          itemProperties['_addon_origin'] = variants[0]['addon_origin'];
        }
        postRequest(variants[0].variantId, quantityCount, itemProperties, false);

      } else {
        closeEverything();
      }
    }
    
  }
  addItem();
} else if (variantId) {
  
  var serializedArray = form.serializeArray();

  $('#loading-overlay').show();
    if(modal) modal.close();
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: serializedArray,
    dataType: 'json',
    error: addToCartFail,
    success: addToCartSuccess,
    cache: false
  });

}
}

function addToCartSuccess(jqXHR, textStatus, errorThrown) {
  var bundleTrigger = document.querySelector('#side-cart [pdp-bundle]')
  if (bundleTrigger && bundleTrigger.querySelector('.clicked')) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'id': bundleTrigger.getAttribute('data-key'),
        'quantity': 0
      })
    }).then(response => {
      window.Branch.cart.updateCartDesc(true);
      return response.json();
    })
  } else {
    window.Branch.cart.updateCartDesc(true);
  }
  window.Branch.cart.updateCartDesc(true);
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);
  $('#loading-overlay').hide();
  Simplistic.openModal('<div class="error-itemincart">'+response.description+'</div>', 'message');
}

window.Branch.cart.updateCartDesc = function(openSideC){
  // console.log('updateCartDesc');
  $.ajax({
  type: 'GET',
  url: '/cart?view=side-cart',
  cache: false,
      success: function(data){
        $('#loading-overlay').hide();
        // $('.side-cart-stand-in').show();

        var animate = true;
        if($('#side-cart').width()>0 && $('#side-cart').hasClass('open')) {
          animate = false;
        }
        $('#side-cart').remove();
        $('#page').append(data);
        if(modal) modal.close();
        setupClydeCartPrompts();
        if(openSideC){showSideCart(animate);
        }
        // setTimeout(function(){
        //   $('.side-cart-stand-in').hide();
        // }, 500);
      }
});
}

//this is for the FSA/HSA messaging on the sidecart
function initFlexMessage(){
    var fsaModal = document.querySelector('.fsa-hsa__side-cart #fsa-hsa-modal');
    var fsaBtn = document.querySelector('.fsa-hsa__side-cart #fsa-hsa-cta');
    var fsaClose = document.querySelector('.fsa-hsa__side-cart #fsa-hsa-close');
    
    if (fsaModal && fsaBtn && fsaClose){
      function addClickListeners(){
        fsaBtn.addEventListener("click", clickedFsaHsa);
        fsaClose.addEventListener("click", closeFsaHsa);
      }

      if (fsaModal){
        document.querySelector("body").appendChild(fsaModal);
      }
      if (fsaBtn && fsaClose){
        addClickListeners();
      }
      function clickedFsaHsa(){
       // $('header').addClass("fsa-disable-header");
        $(fsaModal).removeClass("fsa-modal-invisible");
        $(fsaModal).addClass("fsa-modal-visible");
      }
      function closeFsaHsa(){
        //$('header').removeClass("fsa-disable-header");
        $(fsaModal).removeClass("fsa-modal-visible");
        $(fsaModal).addClass("fsa-modal-invisible");
      }
    }
}

function showSideCart(animate) {
// $('body, html').css({overflow: 'hidden'});
$('#page').addClass('mode-overlay');
if(animate) {
  setTimeout(function(){$('#side-cart').addClass('open')}, 100);
} else {
  $('#side-cart').removeClass('ease-animation-slow');
  $('#side-cart').addClass('open');
  setTimeout(function(){$('#side-cart').addClass('ease-animation-slow')}, 200);
}
Simplistic.trapFocus({
  $container: $('#side-cart'), 
  namespace: 'side-cart'
});

// var fcBadge = document.querySelector("#fc_frame");
// if (fcBadge) {
//   fcBadge.style.marginBottom = "40px";
//   fcBadge.style.transition = "all .5s ease-in";
// }
}

function hideSideCart() {
$('#side-cart').removeClass('open');
$('#page').removeClass('mode-overlay');
// $('body, html').css({overflow: ''});
Simplistic.removeTrapFocus({
  $container: $('#side-cart'), 
  namespace: 'side-cart'
});
// var fcBadge = document.querySelector("#fc_frame");
//   if (fcBadge) {
//     fcBadge.style.marginBottom = "0px";
//   }
}

function setupClydeCartPrompts() {
if (window.Clyde && !window.Clyde.checkReady()) {
  return;
}
var clydeVariants = [];
var clydeVariantIds = [];

var cartRows = $('.clyde-cart-prompt-container');

$.each(cartRows, function(index, itemRow) {
  if($(itemRow).data('item-type') == 'product'){
    var itemVariantId = $(itemRow).data('item-variant-id');
    var itemQty = $(itemRow).data('item-quantity');
    var productName = $(itemRow).data('item-title').replace(' - ',' ').trim();
    clydeVariants.push({
      id: itemVariantId,
      qty : itemQty,
      name: productName
    });
    
    clydeVariantIds.push(itemVariantId);
  }
  
});
if(window.Clyde){
  window.Clyde.loadContractsForProductList(clydeVariantIds);
}

clydeVariants.forEach(function(variant) {
  var promptSelector = '.clyde-cart-prompt-container-' + variant.id;
  var productName = variant.name;
  var countContractInCart = 0;
  $.each($('[data-cart-clyde-contract]'), function(index, contractItem) {
    var contractName = $(contractItem).data('item-title').trim();
        if(contractName.includes(productName)){
          countContractInCart = 1; 
          return false;
        }
  });
  
  if (countContractInCart == 0) {
    
    $(promptSelector).html('');
    if(window.Clyde){
      window.Clyde.appendToSelectorWithSku(variant.id, promptSelector, function() { closeModalCb(variant.qty) });
    }
  }
  
    
  
});

function closeModalCb(qty) {
      var contract;
      if(window.Clyde){
        window.Clyde.getSelectedContract();
      }
      if (contract) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: contract.shopifyVariantId,
            quantity: qty
          },
          dataType: 'json',
          success: function(){
            if($('#side-cart').length > 0) {
              window.Branch.cart.updateCartDesc(true);
            }else{
             window.location.reload();
            }
              //showSideCart(true);
            //window.location.reload();
          },
          error: function(){
            window.Branch.cart.updateCartDesc(true);
            
          }
        });
      }
    };

}
function removeClydeCart(evt){
  if ( $(evt.currentTarget).is( "button" ) 
      || $(evt.currentTarget).is( "input" ) 
     || $(evt.currentTarget).is( "a" ) ) {
    var $remove = $(evt.currentTarget);
    var productName = $remove.data('item-title').replace(' - ',' ').trim();
    var itemVariantId = $remove.data('item-variant-id');
    var removeItems = {};
    removeItems[itemVariantId] = 0;
    
    if($remove.data('item-type') != 'contract'){
      
      $.each($('[data-cart-remove-contract]'), function(index, contractItem) {
        var contractName = $(contractItem).data('item-title').trim();
        if(contractName.includes(productName)){
          var contractVariantId = $(contractItem).data('item-variant-id');
          removeItems[contractVariantId] = 0;
          $('#updates_' + contractVariantId).val(0);
        }
      });
      
    }
/*
    $.post('/cart/update.js', {updates: removeItems},'json').done(function() {
        //location.reload();
    }).fail(function() {
        //location.reload();
    }); 
    */
  }
  
}
function updateClydeCart(evt){
if ($(evt.currentTarget).is( "input" ) ) {
  var $input = $(evt.target);
    var itemIndex = $input.data('quantity-item');
    var item_qty = $input.val();
    var itemVariantId = $input.data('item-variant-id');
    var updateItems = {};
    var needUpdate = false;

    //updateItems[itemVariantId] = item_qty;
    
    if($input.data('item-type') != 'contract'){
      var productName = $input.data('item-title').trim().replace(' - ',' ').trim();
      $.each($('[data-quantity-input-contract]'), function(index, contractItem) {
        
        var contractName = $(contractItem).data('item-title').trim();
        if(contractName.includes(productName)){
    var contractQty = $(contractItem).val();
          var contractVariantId = $(contractItem).data('item-variant-id');
          if(contractQty > item_qty){
            $(contractItem).val(item_qty);
            return false;
          }
        }
      })
      
    }else{
      
      var contractName = $input.data('item-title').trim();
      $.each($('[data--input-product]'), function(index, productItem) {
        var productName = $(productItem).data('item-title').trim().replace(' - ',' ').trim();
        if(contractName.includes(productName)){
          var productQty = $(productItem).val();
          if(item_qty > productQty){
            $input.val(productQty);
            return false;
          }
          
          return false;
        }
      });
      
    }
  
}
    return;
}

window.SimplisticJS = function (){
this.formatMoney = "$ \{\{amount\}\}";
this.beforeTrapFocus = false;

/**
 * Traps the focus in a particular container
 *
 * @param {object} options - Options to be used
 * @param {jQuery} options.$container - Container to trap focus within
 * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
 * @param {string} options.namespace - Namespace used for new focus event handler
 */
this.trapFocus = function(options) {
  this.beforeTrapFocus = $(':focus');
  var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

  if (!options.$elementToFocus) {
    options.$elementToFocus = options.$container;
  }

  options.$container.attr('tabindex', '-1');
  options.$elementToFocus.focus();

  $(document).on(eventName, function(evt) {
    if (
      options.$container[0] !== evt.target &&
      !options.$container.has(evt.target).length
    ) {
      options.$container.focus();
    }
  });
},

/**
 * Removes the trap of focus in a particular container
 *
 * @param {object} options - Options to be used
 * @param {jQuery} options.$container - Container to trap focus within
 * @param {string} options.namespace - Namespace used for new focus event handler
 */
this.removeTrapFocus = function(options) {
  var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

  if (options.$container && options.$container.length) {
    options.$container.removeAttr('tabindex');
  }
  if(this.beforeTrapFocus) {
    this.beforeTrapFocus.focus();
      this.beforeTrapFocus = false;
  }

  $(document).off(eventName);
}

this.handleize = function (str) {
  //source https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
  return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};

this.reducedMotion = function() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

this.getQueryParam = function(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

this.randomstring = function(L){
  var s= '';
  var randomchar=function(){
    var n= Math.floor(Math.random()*62);
    if(n<10) return n; //1-10
    if(n<36) return String.fromCharCode(n+55); //A-Z
    return String.fromCharCode(n+61); //a-z
  }
  while(s.length< L) s+= randomchar();
  return s;
}

this.validateEmail = function(email) {
  var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
  return re.test(email);
}

this.openModal = function(content, css, trigger, element) {
  modal = new tingle.modal({
    closeMethods: ['overlay', 'button', 'escape'],
    closeLabel: "Close",
    cssClass: [css],
    onOpen: function() {
      let tingle_container = document.querySelector('.tingle-modal');
      if(tingle_container){
        tingle_container.setAttribute('data-trigger', trigger)
      }
      if(trigger == "bundle-builder-form" || trigger == "comparison-chart") {
        let isAddOnsTab = false;
        if(element){
          isAddOnsTab = element.data('addons-tab');
        }
        if(trigger == "bundle-builder-form"){
          tingle_container.querySelector('.main-product').setAttribute('data-bundle-builder-pop-up', true);
          
          // Disable out-of-stock variants in bundle builder after a short delay to ensure DOM is ready
          setTimeout(function() {
            tingle_container.querySelectorAll('.swatch-element.soldout').forEach(function(swatchElement) {
              swatchElement.classList.add('option-not-available');
              let input = swatchElement.querySelector('input');
              if(input) {
                input.disabled = true;
              }
            });
          }, 100);
        }
        if(tingle_container){    
          window.Branch.product.quickViewUpdateOnOpen(modal, tingle_container, trigger, isAddOnsTab);
        }
      } else if(trigger = "quick-view-link"){
        if(element && element.closest('.main-product[data-quick-view="false"]').length > 0){
          if(tingle_container){
            window.Branch.product.quickViewUpdateOnOpen(modal, tingle_container, 'main-product', false);
          }
        } else if(element && element.closest('#side-cart').length > 0){
          if(tingle_container){
            window.Branch.product.quickViewUpdateOnOpen(modal, tingle_container, 'side-cart', false);
          }
        }
      } 
  },
    beforeClose: function() {
      if(trigger == "bundle-builder-form" || trigger == "comparison-chart") {
        window.Branch.collection.removeEventListeners();
      }
    }
  });
  modal.setContent(content);
  modal.open();
}
};
window.Simplistic = new SimplisticJS();

window.addEventListener('load', function(){
  !function(i){"use strict";i.fn.equalHeight=function(){var t=[];return i.each(this,function(e,n){var r,s=i(n);r="border-box"===s.css("box-sizing")||"border-box"===s.css("-moz-box-sizing")?s.innerHeight():s.height(),t.push(r)}),this.css("height",Math.max.apply(window,t)+"px"),this},i.fn.equalHeightGrid=function(t){var e=this.filter(":visible");e.css("height","auto");for(var n=0;n<e.length;n++)if(n%t==0){for(var r=i(e[n]),s=1;s<t;s++)r=r.add(e[n+s]);r.equalHeight()}return this},i.fn.detectGridColumns=function(){var t=0,e=0;return this.filter(":visible").each(function(n,r){var s=i(r).offset().top;if(0!==t&&s!==t)return!1;e++,t=s}),e};var t=0;i.fn.responsiveEqualHeightGrid=function(){var e=this,n=".grids_"+t;function r(){var i=e.detectGridColumns();e.equalHeightGrid(i)}return e.data("grids-event-namespace",n),i(window).bind("resize"+n+" load"+n,r),r(),t++,this},i.fn.responsiveEqualHeightGridDestroy=function(){return this.css("height","auto"),i(window).unbind(this.data("grids-event-namespace")),this}}(window.jQuery);
});

// $('.c-fcp-section .c-fcp-slider .c-fcp-vendor').equalHeight();
// $('.c-t-flex-item .c-t-flex-item-2 .c-t-flex-item-2-content').equalHeight();
// $('.c-lwt-flex-container .c-lwt-flex-item .c-lwt-img-container').equalHeight();

function addToCartAddOns(id, bundle, quantity){
  $('#loading-overlay').show();
  $('.tingle-modal[data-add-on-quick-view-link="true"]').hide();

  let addonQuantity = 1;
  if(typeof quantity !== 'undefined' && typeof quantity !== 'null' ){
    addonQuantity = quantity;
  }
  let formData = {};
  let addOnVariantId = document.getElementById('product-'+id+'-variant').value;
  if(bundle) {
    const bundleProductsObject = JSON.parse(document.querySelector(`#side-cart-bundle-products`).innerText);
    let bundleProducts = bundleProductsObject[`${id}`];


    const bundleProductConstituents = bundleProducts[`${addOnVariantId}`];
    let itemsArray = [];
    if(bundleProductConstituents && bundleProductConstituents.length > 0) {
      bundleProductConstituents.forEach((constituent) => {
        let variantObject = {};
        variantObject['id'] = constituent.variantId;
        variantObject['quantity'] = constituent.quantity;
        itemsArray.push(variantObject);
      })
    } else {
      itemsArray = [{'id': addOnVariantId, 'quantity': 1}];
    }
    formData['items'] = itemsArray
  } else {
    formData['items'] = [{
       'id': addOnVariantId,
       'quantity': addonQuantity
       }]
  }

  var shipping = ''
  let msbdInput = document.querySelector(`.msbd-message__input[data-variant-id="${addOnVariantId}"]`);
  if(id && msbdInput){
    shipping = msbdInput.value;
    formData['items'][0][`properties`] = {'_ship_date': shipping, '_addon_origin': 'side-cart'}
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
   addToCartSuccess();
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
    $('#loading-overlay').hide();
    $('.tingle-modal[data-add-on-quick-view-link="true"]').show();
  });
}

